var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app-content-inner" } }, [
    _c(
      "div",
      {
        staticClass: "apps-list",
        class: {
          installed: _vm.useBundleView || _vm.useListView,
          store: _vm.useAppStoreView
        },
        attrs: { id: "apps-list" }
      },
      [
        _vm.useListView
          ? [
              _vm.showUpdateAll
                ? _c("div", { staticClass: "counter" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.n(
                            "settings",
                            "%n app has an update available",
                            "%n apps have an update available",
                            _vm.counter
                          )
                        ) +
                        "\n\t\t\t\t"
                    ),
                    _vm.showUpdateAll
                      ? _c(
                          "button",
                          {
                            staticClass: "primary",
                            attrs: { id: "app-list-update-all" },
                            on: { click: _vm.updateAll }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.t("settings", "Update all")) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "transition-group",
                {
                  staticClass: "apps-list-container",
                  attrs: { name: "app-list", tag: "div" }
                },
                _vm._l(_vm.apps, function(app) {
                  return _c("AppItem", {
                    key: app.id,
                    attrs: { app: app, category: _vm.category }
                  })
                }),
                1
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.useBundleView
          ? _c(
              "transition-group",
              {
                staticClass: "apps-list-container",
                attrs: { name: "app-list", tag: "div" }
              },
              [
                _vm._l(_vm.bundles, function(bundle) {
                  return [
                    _c("div", { key: bundle.id, staticClass: "apps-header" }, [
                      _c("div", { staticClass: "app-image" }),
                      _vm._v(" "),
                      _c("h2", [
                        _vm._v(_vm._s(bundle.name) + " "),
                        _c("input", {
                          attrs: {
                            type: "button",
                            value: _vm.bundleToggleText(bundle.id)
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleBundle(bundle.id)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "app-version" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "app-level" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "app-groups" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "actions" }, [
                        _vm._v("\n\t\t\t\t\t\t \n\t\t\t\t\t")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.bundleApps(bundle.id), function(app) {
                      return _c("AppItem", {
                        key: bundle.id + app.id,
                        attrs: { app: app, category: _vm.category }
                      })
                    })
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.useAppStoreView
          ? _vm._l(_vm.apps, function(app) {
              return _c("AppItem", {
                key: app.id,
                attrs: { app: app, category: _vm.category, "list-view": false }
              })
            })
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "apps-list installed", attrs: { id: "apps-list-search" } },
      [
        _c(
          "div",
          { staticClass: "apps-list-container" },
          [
            _vm.search !== "" && _vm.searchApps.length > 0
              ? [
                  _c("div", { staticClass: "section" }, [
                    _c("div"),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "5" } }, [
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.t("settings", "Results from other categories")
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.searchApps, function(app) {
                    return _c("AppItem", {
                      key: app.id,
                      attrs: {
                        app: app,
                        category: _vm.category,
                        "list-view": true
                      }
                    })
                  })
                ]
              : _vm._e()
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _vm.search !== "" &&
    !_vm.loading &&
    _vm.searchApps.length === 0 &&
    _vm.apps.length === 0
      ? _c(
          "div",
          {
            staticClass: "emptycontent emptycontent-search",
            attrs: { id: "apps-list-empty" }
          },
          [
            _c("div", {
              staticClass: "icon-settings-dark",
              attrs: { id: "app-list-empty-icon" }
            }),
            _vm._v(" "),
            _c("h2", [
              _vm._v(
                _vm._s(_vm.t("settings", "No apps found for your version"))
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { attrs: { id: "searchresults" } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }